(() => {
  'use strict';

  if (window.__mlineartMobilePaidUxBound) return;
  window.__mlineartMobilePaidUxBound = true;

  const componentSelector = '[data-mobile-paid-ux]';
  let syncTimer;

  function readVariants(component) {
    try {
      return JSON.parse(component.querySelector('[data-mobile-paid-ux-variants]')?.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function connectTarget(component, productInfo) {
    const target = productInfo?.querySelector('.easify-product-options, [data-mlineart-personalization]')
      || productInfo?.querySelector('[data-block-type="buy-buttons"]');
    const button = component.querySelector('[data-mobile-personalize-cta]');

    if (!target || !button || target === component.__personalizationTarget) return;

    component.__personalizationTarget = target;
    if (!target.id) target.id = `mlineart-personalization-target-${component.dataset.productId || 'product'}`;
    button.setAttribute('aria-controls', target.id);
    component.__intersectionObserver?.disconnect();
    component.__intersectionObserver = new IntersectionObserver((entries) => {
      button.hidden = entries.some((entry) => entry.isIntersecting);
    }, { rootMargin: '0px 0px -35% 0px', threshold: .08 });
    component.__intersectionObserver.observe(target);
  }

  function syncComponent(component) {
    const productInfo = component.closest('.product-info');
    const variantInput = productInfo?.querySelector('product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    const variant = readVariants(component).find((item) => String(item.id) === String(variantInput?.value));

    if (variant) {
      const currency = component.dataset.currency || window.Shopify?.currency?.active;

      if (!currency) {
        connectTarget(component, productInfo);
        return;
      }

      const formattedPrice = new Intl.NumberFormat(
        component.dataset.locale || document.documentElement.lang || navigator.language,
        {
          style: 'currency',
          currency
        }
      ).format(variant.price / 100);
      const label = component.querySelector('[data-mobile-personalize-label]');
      const startingPrice = component.querySelector('[data-mobile-starting-price]');
      const nextLabel = (component.dataset.labelTemplate || '').replace('__PRICE__', formattedPrice);
      const nextStartingPrice = (component.dataset.startingTemplate || '').replace('__PRICE__', formattedPrice);

      if (label && label.textContent.trim() !== nextLabel) label.textContent = nextLabel;
      if (startingPrice && startingPrice.textContent.trim() !== nextStartingPrice) {
        startingPrice.textContent = nextStartingPrice;
      }
    }

    connectTarget(component, productInfo);
  }

  function syncAll() {
    document.querySelectorAll(componentSelector).forEach(syncComponent);
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncAll, 80);
  }

  document.addEventListener('change', (event) => {
    if (event.target.closest('.product-info')) scheduleSync();
  });

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }
})();
